import { useEffect, useState } from "react";
import { GLOBAL_IMAGES } from "../../assets/asset";
import BigPrimaryButton from "../ui/BigPrimaryButton";

const BUBBLE_COPY = {
  true:
    "MathDingo personalises lessons, practice and assessments to match their current grade and confidence level.",
  1: "Pick the grade that feels right today. You can always change it later from settings.",
  2: "Choose a plan to unlock lessons, practice and assessments for your child.",
};

export default function FirstLoginDemo({ showDemo, handleDemo }) {
  const [bubbleImageFailed, setBubbleImageFailed] = useState(false);
  const isIntroStep = showDemo === true || showDemo === 1;
  const bubbleCopy = BUBBLE_COPY[String(showDemo)] || BUBBLE_COPY.true;
  const bubbleImage =
    showDemo === true
      ? GLOBAL_IMAGES.chatBubble1
      : showDemo === 1
      ? GLOBAL_IMAGES.chatBubble2
      : GLOBAL_IMAGES.chatBubble;

  useEffect(() => {
    setBubbleImageFailed(false);
  }, [bubbleImage]);

  useEffect(() => {
    const scrollY = window.scrollY;
    const { style: bodyStyle } = document.body;
    const { style: htmlStyle } = document.documentElement;

    const previousBodyOverflow = bodyStyle.overflow;
    const previousBodyPosition = bodyStyle.position;
    const previousBodyTop = bodyStyle.top;
    const previousBodyWidth = bodyStyle.width;
    const previousHtmlOverflow = htmlStyle.overflow;

    htmlStyle.overflow = "hidden";
    bodyStyle.overflow = "hidden";
    bodyStyle.position = "fixed";
    bodyStyle.top = `-${scrollY}px`;
    bodyStyle.width = "100%";

    return () => {
      htmlStyle.overflow = previousHtmlOverflow;
      bodyStyle.overflow = previousBodyOverflow;
      bodyStyle.position = previousBodyPosition;
      bodyStyle.top = previousBodyTop;
      bodyStyle.width = previousBodyWidth;
      window.scrollTo(0, scrollY);
    };
  }, []);

  return (
    <div className="first-login-demo-overlay fixed inset-0 z-40 overflow-hidden overscroll-y-none bg-black/60">
      <div className="first-login-demo-stage">
        <img
          src={GLOBAL_IMAGES.foxImage}
          alt=""
          className={`first-login-demo-fox ${
            isIntroStep ? "first-login-demo-fox-bottom" : "first-login-demo-fox-top"
          }`}
        />
        <img
          className={`first-login-demo-bubble ${
            isIntroStep ? "first-login-demo-bubble-bottom" : "first-login-demo-bubble-top"
          } ${bubbleImageFailed ? "first-login-demo-bubble-hidden" : ""}`}
          src={bubbleImage}
          alt=""
          onError={() => setBubbleImageFailed(true)}
        />
        <div
          className={`first-login-demo-bubble-fallback ${
            isIntroStep
              ? "first-login-demo-bubble-bottom"
              : "first-login-demo-bubble-top"
          } ${bubbleImageFailed ? "first-login-demo-bubble-fallback-visible" : ""}`}
          aria-hidden={!bubbleImageFailed}
        >
          {bubbleCopy}
        </div>
      </div>
      <div className="first-login-demo-action">
        <BigPrimaryButton
          onClick={handleDemo}
          title={isIntroStep ? "Next" : "Choose Your Plan"}
          buttonClassName="first-login-demo-button years-content-action-button bg-primary-button-dark-blue"
          textClassName="first-login-demo-button-label font-mali font-bold text-white"
        />
      </div>
    </div>
  );
}
